/* YourMelody — Souvenir physique upsell (preview funnel).
   Isolated UI component. Exposes window.YMSouvenir so preview-player.js can read the
   selection and submit the cart (it owns the /cart/add.js + checkout redirect).
   The guided quiz (quiz-funnel.*) is NOT touched by this file. */
(function () {
  'use strict';

  var PROP_LABELS = {
    fr: { songTitle: 'Titre de la chanson', artist: 'Artiste', socle: 'Socle', yes: 'Oui' },
    en: { songTitle: 'Song title', artist: 'Artist', socle: 'Wooden base', yes: 'Yes' },
    de: { songTitle: 'Liedtitel', artist: 'Künstler', socle: 'Holzsockel', yes: 'Ja' },
    es: { songTitle: 'Título de la canción', artist: 'Artista', socle: 'Base de madera', yes: 'Sí' }
  };
  var MSG = {
    fr: { fill: 'Veuillez renseigner le titre, l’artiste et ajouter une photo.', tooBig: 'Photo trop volumineuse (max 20 Mo).', wrongType: 'Format non supporté. Utilisez JPG, PNG ou WEBP.', heicFail: 'Conversion de la photo iPhone échouée. Essayez une capture d’écran ou un JPG.', converting: 'Conversion de la photo iPhone…' },
    en: { fill: 'Please enter the title, the artist and add a photo.', tooBig: 'Photo too large (max 20 MB).', wrongType: 'Unsupported format. Use JPG, PNG or WEBP.', heicFail: 'iPhone photo conversion failed. Try a screenshot or a JPG.', converting: 'Converting iPhone photo…' },
    de: { fill: 'Bitte Titel, Künstler und ein Foto angeben.', tooBig: 'Foto zu groß (max 20 MB).', wrongType: 'Format nicht unterstützt. JPG, PNG oder WEBP.', heicFail: 'iPhone-Foto-Konvertierung fehlgeschlagen. Screenshot oder JPG versuchen.', converting: 'iPhone-Foto wird konvertiert…' },
    es: { fill: 'Introduce el título, el artista y añade una foto.', tooBig: 'Foto demasiado grande (máx 20 MB).', wrongType: 'Formato no admitido. Usa JPG, PNG o WEBP.', heicFail: 'Conversión de la foto del iPhone fallida. Prueba una captura o un JPG.', converting: 'Convirtiendo la foto del iPhone…' }
  };

  var root = null;
  var els = {};
  var locale = 'fr';
  var state = { product: null, socle: false, songTitle: '', artist: '' };
  var photoFile = null;
  var handlers = { onSkip: null, onConfirm: null };
  var heic2anyPromise = null;

  function L() { return PROP_LABELS[locale] || PROP_LABELS.fr; }
  function M() { return MSG[locale] || MSG.fr; }

  function init() {
    root = document.querySelector('[data-ym-souvenir]');
    if (!root) return;
    locale = (root.getAttribute('data-locale') || 'fr').slice(0, 2).toLowerCase();
    if (!PROP_LABELS[locale]) locale = 'fr';

    els.group = root.querySelector('[data-ym-product-group]');
    els.form = root.querySelector('[data-ym="souvenir-form"]');
    els.socleRow = root.querySelector('[data-ym="souvenir-socle-row"]');
    els.socleCb = root.querySelector('[data-ym-field="socle"]');
    els.photoInput = root.querySelector('[data-ym="photo-input"]');
    els.photoPreview = root.querySelector('[data-ym="photo-preview"]');
    els.photoError = root.querySelector('[data-ym="photo-error"]');
    els.photoBtnLabel = root.querySelector('[data-ym="photo-btn-label"]');
    els.formError = root.querySelector('[data-ym="souvenir-error"]');
    els.confirm = root.querySelector('[data-ym="souvenir-confirm"]');
    els.skip = root.querySelector('[data-ym="souvenir-skip"]');

    YMSouvenir.variants = {
      plaque: root.getAttribute('data-variant-plaque') || '',
      magnet: root.getAttribute('data-variant-magnet') || '',
      socle: root.getAttribute('data-variant-socle') || ''
    };

    // Product cards (toggle select)
    root.querySelectorAll('[data-ym-product]').forEach(function (card) {
      card.addEventListener('click', function () {
        var id = card.getAttribute('data-ym-product');
        var wasActive = card.getAttribute('aria-pressed') === 'true';
        root.querySelectorAll('[data-ym-product]').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        if (wasActive) {
          state.product = null;
        } else {
          card.setAttribute('aria-pressed', 'true');
          state.product = id;
        }
        refreshReveal();
        hideFormError();
      });
    });

    if (els.socleCb) {
      els.socleCb.addEventListener('change', function () { state.socle = els.socleCb.checked; });
    }

    // Text inputs + char counters
    root.querySelectorAll('[data-ym-field="songTitle"],[data-ym-field="artist"]').forEach(function (input) {
      var field = input.getAttribute('data-ym-field');
      var counter = root.querySelector('[data-ym-counter-for="' + field + '"]');
      var max = input.getAttribute('maxlength') || '';
      input.addEventListener('input', function () {
        state[field] = input.value;
        if (counter) counter.textContent = input.value.length + '/' + max;
        hideFormError();
      });
    });

    if (els.photoInput) els.photoInput.addEventListener('change', onPhotoSelected);

    if (els.confirm) els.confirm.addEventListener('click', function () {
      if (!state.product) { fireSkip(); return; }
      if (!validate()) { showFormError(M().fill); return; }
      if (handlers.onConfirm) handlers.onConfirm(getState());
    });
    if (els.skip) els.skip.addEventListener('click', fireSkip);
  }

  function fireSkip() { if (handlers.onSkip) handlers.onSkip(); }

  function refreshReveal() {
    if (els.group) els.group.setAttribute('data-active', state.product || '');
    if (state.product === 'plaque') {
      if (els.form) els.form.hidden = false;
      if (els.socleRow) els.socleRow.hidden = false;
    } else if (state.product === 'magnet') {
      if (els.form) els.form.hidden = false;
      if (els.socleRow) els.socleRow.hidden = true;
      state.socle = false;
      if (els.socleCb) els.socleCb.checked = false;
    } else {
      if (els.form) els.form.hidden = true;
      if (els.socleRow) els.socleRow.hidden = true;
      state.socle = false;
      if (els.socleCb) els.socleCb.checked = false;
    }
  }

  function validate() {
    return !!(state.songTitle.trim() && state.artist.trim() && photoFile);
  }

  function getState() {
    return {
      product: state.product,
      socle: state.socle,
      songTitle: state.songTitle.trim(),
      artist: state.artist.trim(),
      photoFile: photoFile
    };
  }

  function buildPhysicalProperties() {
    var lab = L();
    var props = {};
    props[lab.songTitle] = (state.songTitle || '').trim();
    props[lab.artist] = (state.artist || '').trim();
    if (state.product === 'plaque' && state.socle) props[lab.socle] = lab.yes;
    return props;
  }

  function setBusy(busy) {
    if (els.confirm) els.confirm.disabled = busy;
    if (els.skip) els.skip.disabled = busy;
  }

  function showFormError(msg) {
    if (!els.formError) return;
    els.formError.textContent = msg;
    els.formError.hidden = false;
    els.formError.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function hideFormError() { if (els.formError) els.formError.hidden = true; }

  // ============================================================
  //  Photo handling (HEIC/HEIF aware — iPhone default)
  // ============================================================
  async function onPhotoSelected(ev) {
    var errEl = els.photoError;
    var preview = els.photoPreview;
    var file = ev.target.files && ev.target.files[0];
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    if (!file) { photoFile = null; if (preview) preview.innerHTML = '<span>🖼</span>'; return; }

    var isHeic = /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name);
    var originalBtnText = els.photoBtnLabel ? els.photoBtnLabel.textContent : '';
    if (isHeic) {
      if (els.photoBtnLabel) els.photoBtnLabel.textContent = M().converting;
      if (preview) preview.innerHTML = '<span style="font-size:22px;">⏳</span>';
      try {
        file = await convertHeicToJpeg(file);
        if (els.photoBtnLabel) els.photoBtnLabel.textContent = originalBtnText;
      } catch (e) {
        console.error('[ym-souvenir] HEIC conversion failed:', e);
        if (els.photoBtnLabel) els.photoBtnLabel.textContent = originalBtnText;
        if (errEl) { errEl.textContent = M().heicFail; errEl.hidden = false; }
        ev.target.value = '';
        if (preview) preview.innerHTML = '<span>🖼</span>';
        return;
      }
    }

    if (file.size > 20 * 1024 * 1024) {
      if (errEl) { errEl.textContent = M().tooBig; errEl.hidden = false; }
      ev.target.value = '';
      if (preview) preview.innerHTML = '<span>🖼</span>';
      return;
    }
    if (!/^image\/(jpe?g|png|webp)$/i.test(file.type)) {
      if (errEl) { errEl.textContent = M().wrongType; errEl.hidden = false; }
      ev.target.value = '';
      if (preview) preview.innerHTML = '<span>🖼</span>';
      return;
    }

    photoFile = file;
    var url = URL.createObjectURL(file);
    if (preview) preview.innerHTML = '<img src="' + url + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:8px;">';
    hideFormError();
  }

  function heicViaCanvas(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        if (!canvas.width || !canvas.height) { URL.revokeObjectURL(url); reject(new Error('Decoded image has zero size')); return; }
        canvas.getContext('2d').drawImage(img, 0, 0);
        canvas.toBlob(function (blob) {
          URL.revokeObjectURL(url);
          if (blob) resolve(blob); else reject(new Error('Canvas toBlob returned null'));
        }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('Native HEIC decode not supported')); };
      img.src = url;
    });
  }

  async function convertHeicToJpeg(file) {
    var baseName = (file.name || 'photo').replace(/\.(heic|heif)$/i, '') + '.jpg';
    try {
      var blob = await heicViaCanvas(file);
      return new File([blob], baseName, { type: 'image/jpeg' });
    } catch (canvasErr) {
      console.info('[ym-souvenir] Canvas HEIC decode failed, trying heic2any…', canvasErr.message);
    }
    await ensureHeic2Any();
    var result = await window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 });
    var jpeg = Array.isArray(result) ? result[0] : result;
    return new File([jpeg], baseName, { type: 'image/jpeg' });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src; s.async = true; s.crossOrigin = 'anonymous';
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('Script load failed: ' + src)); };
      document.head.appendChild(s);
    });
  }
  function ensureHeic2Any() {
    if (window.heic2any) return Promise.resolve();
    if (heic2anyPromise) return heic2anyPromise;
    heic2anyPromise = loadScript('https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js')
      .catch(function () { return loadScript('https://unpkg.com/heic2any@0.0.4/dist/heic2any.min.js'); })
      .then(function () { if (!window.heic2any) throw new Error('heic2any loaded but undefined'); });
    return heic2anyPromise;
  }

  // ============================================================
  //  Public API (consumed by preview-player.js)
  // ============================================================
  var YMSouvenir = {
    variants: { plaque: '', magnet: '', socle: '' },
    onSkip: function (fn) { handlers.onSkip = fn; },
    onConfirm: function (fn) { handlers.onConfirm = fn; },
    getState: getState,
    buildPhysicalProperties: buildPhysicalProperties,
    setBusy: setBusy,
    showFormError: showFormError
  };
  window.YMSouvenir = YMSouvenir;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
